import * as Actions from '../action/investigationAction';

const initialState = {
  investigationActionData: [],
  investigationActionsEnum: [],
  investigationActionsByInvestigationId: [],
  loading: true,
};

const investigationActionReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GET_INVESTIGATION_ACTION:
      return {
        ...state,
        investigationActionData: action.payload,
        loading: false,
      };
    case Actions.GET_INVESTIGATION_ACTION_BY_ID:
      return {
        ...state,
        investigationActionData: state.investigationActionData.map(item =>
            item._id === action.payload._id ? action.payload : item
        ).concat(
            state.investigationActionData.some(item => item._id === action.payload._id) ? [] : [action.payload]
        ),
        loading: false,
      };
    case Actions.GET_INVESTIGATION_ACTIONS_ENUM:
      return {
        ...state,
        investigationActionsEnum: action.payload,
        loading: false,
      };
    case Actions.CREATE_INVESTIGATION_ACTION:
      return {
        ...state,
        investigationActionData: [...state.investigationActionData, action.payload],
      };
    case Actions.CREATE_LIST_INVESTIGATION_ACTION:
      return {
        ...state,
        investigationActionData: [...state.investigationActionData, ...action.payload],
      };
    case Actions.UPDATE_INVESTIGATION_ACTION:
      return {
        ...state,
        investigationActionData: state.investigationActionData.map((item) =>
            item._id === action.payload._id ? action.payload : item
        ),
      };
    case Actions.DELETE_INVESTIGATION_ACTION:
      return {
        ...state,
        investigationActionData: state.investigationActionData.filter((item) => item._id !== action.payload),
      };
    case Actions.GET_INVESTIGATION_ACTIONS_BY_INVESTIGATION_ID:
      return {
        ...state,
        investigationActionsByInvestigationId: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default investigationActionReducer;
